import type { ReactNode } from 'react';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';
import { SearchHotkey } from './SearchHotkey';

/* .kb-public zet de publieke leesschaal aan (theme.css, sectie 6): elke
   tekstsport één maat groter dan de beheerladder. Een kale <div> maakt geen
   containing block, dus de sticky topbalk en de fixed modals blijven werken.
   De klasse dient óók als printhaak: print.css verbergt .kb-public > header,
   > footer en aside. */
export function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <div className="kb-public">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-200 focus:rounded-md focus:bg-accent focus:px-4 focus:py-2 focus:font-semibold focus:text-accent-on"
      >
        Naar de inhoud
      </a>
      <SiteHeader />
      <SearchHotkey />
      {/* tabIndex=-1: zonder dat verplaatst een fragmentlink in Safari en
          oudere WebKit de focus niet, en doet de skip-link dus niets. */}
      <main id="main" tabIndex={-1} className="focus:outline-none">{children}</main>
      <SiteFooter />
    </div>
  );
}

/** Zelfde schil, maar zonder de vaste <main>-wrapper: de artikelpagina zet
 *  zijn eigen <main> neer omdat de leeslay-out een eigen breedte en padding
 *  heeft. De skip-link en de landmarks blijven zo wél op één plek staan. */
export function PublicShell({ children }: { children: ReactNode }) {
  return (
    <div className="kb-public">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-200 focus:rounded-md focus:bg-accent focus:px-4 focus:py-2 focus:font-semibold focus:text-accent-on"
      >
        Naar de inhoud
      </a>
      <SiteHeader />
      <SearchHotkey />
      {children}
      <SiteFooter />
    </div>
  );
}
